import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

$(".section2 ul li:not(:last-child)").click(function() {
    $(".culture-pop").css('display','flex');
    let index = $(this).index();
    $(".culture-item .item").eq(index).addClass("active").siblings().removeClass("active");
})
$(".culture-pop .model").click(function() {
    $(".culture-pop").hide();
    $(".culture-item .item").removeClass("active");
})
$(".culture-pop .out").click(function() {
    $(".culture-pop").hide();
    $(".culture-item .item").removeClass("active");
})